import React, { useEffect } from "react";
import { useOnClickOutside } from "usehooks-ts";

import Button from "components/common/ui/Button/Button";
import { SubscribeBackToStockDropdownContainer } from "./SubscribeBackToStockButton.Styled";
import { useMatch } from "react-router";
import { useTranslation } from "react-i18next";

const SubscribeBackToStockButton = ({ selectedVariantId }: any) => {
  const pathMatch = useMatch("/:locale/*");
  const [isOpen, setIsOpen] = React.useState(false);
  const [apiKey, setApiKey] = React.useState<string | null>(null);
  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState<string | null>(null);
  const { t } = useTranslation();
  const [formIsSent, setFormIsSent] = React.useState(true);

  useEffect(() => {
    if (!pathMatch?.params.locale) {
      return;
    }

    try {
      const { REACT_APP_KLAVYIO_FORM_ID: IDS = "{}" } = process.env;
      const parsedIds = JSON.parse(IDS);

      if (parsedIds[pathMatch.params.locale].apiKey) {
        setApiKey(parsedIds[pathMatch.params.locale].apiKey || null);
      } else {
        console.warn("Klaviyo apiKey not found for this locale.");
      }
    } catch (error) {
      console.error("Error parsing Klaviyo IDS configuration:", error);
    }
  }, [pathMatch]);


  const handleFormTrigger = () => {
    setIsOpen((prev) => !prev);
  };

  const menuRef = React.useRef(null);
  useOnClickOutside(menuRef, () => {
    setIsOpen(false);
    setFormIsSent(false);
  });

  const handleBtsEmailChange = (e: any) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    setError(null);
  }

  const handleBtsSubscription = () => {
    if (!email) {
      setError(t('pdp.back_to_stock.error_required_email_field'));
      return;
    }
    // Validare simplă pentru email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      setError(t('pdp.back_to_stock.error_invalid_email_field'));
      return;
    }

    // Klavyio fetch
    if (!apiKey) return;

    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${apiKey}`;

    const data = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: [
            'EMAIL'
          ],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$bigcommerce:::$default:::${selectedVariantId}`
            }
          }
        }
      }
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2025-01-15',
      },
      body: JSON.stringify(data),
    }).then(response => {
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Display success message after sending form
      setFormIsSent(true);
      //return response.json(); // Or response.text() if the server returns plain text
    }).catch(error => {
      console.error('Error:', error);
    });
  }

  return (
    <SubscribeBackToStockDropdownContainer className="back-to-stock">
      <Button variant="primary_01"
        fullWidth
        onClick={handleFormTrigger}>
        {t('pdp.back_to_stock.trigger_button')}
      </Button>

      <div
        className="bts-container"
        style={{ display: isOpen ? "block" : "none" }}
        ref={menuRef}
      >

        {formIsSent ? (
          <p className='bts-success-message'>
            {t('pdp.back_to_stock.form_success_message')}
          </p>
        ) : (
          <>
            <p className='bts-title'>
              <span>
                <strong>
                  <span>{t('pdp.back_to_stock.title')}</span>
                </strong>
              </span>
            </p>
            <p className='bts-subtitle'>
              <span>{t('pdp.back_to_stock.subtitle')}</span>
            </p>

            <div className="input-container">
              <input name='email'
                type='email'
                value={email}
                onChange={handleBtsEmailChange}
                placeholder='Email'
                className="bts-email-input" />
              {error && (
                <p className='email-error bts-error'>{error}</p>
              )}
            </div>

            <div className='bts-button-container'>
              <button className="bts-button-input"
                type="button"
                onClick={handleBtsSubscription}>
                {t('pdp.back_to_stock_submit_form_button')}
              </button>
            </div>
          </>
        )}
      </div>

    </SubscribeBackToStockDropdownContainer>
  );
};

export default SubscribeBackToStockButton;
